import { render, staticRenderFns } from "./socials.vue?vue&type=template&id=6e2334d4&scoped=true&"
import script from "./socials.vue?vue&type=script&lang=js&"
export * from "./socials.vue?vue&type=script&lang=js&"
import style0 from "./socials.vue?vue&type=style&index=0&id=6e2334d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2334d4",
  null
  
)

export default component.exports